<template>
  <div class="w-full">
    <!-- Section Title -->
    <button
      type="button"
      class="flex w-full min-w-0 items-center justify-between gap-2 px-3 py-3 text-left"
      @click="$emit('toggle')"
    >
      <span class="min-w-0 flex-1 text-sm font-medium text-subtitle-gray">
        {{ title }}
      </span>
      <ChevronDownIcon
        class="size-4 shrink-0 text-subtitle-gray transition-transform duration-200"
        :class="{ 'rotate-180': expanded }"
      />
    </button>

    <!-- Section Content -->
    <Transition
      enter-active-class="transition-all duration-200 ease-out"
      enter-from-class="opacity-0 max-h-0"
      enter-to-class="opacity-100 max-h-96"
      leave-active-class="transition-all duration-200 ease-in"
      leave-from-class="opacity-100 max-h-96"
      leave-to-class="opacity-0 max-h-0"
    >
      <div
        v-show="expanded"
        class="flex w-full min-w-0 flex-col gap-1 border-b border-grey-100 pb-3 overflow-hidden"
      >
        <slot />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ChevronDownIcon } from '@ecx/ui/icons'

defineProps<{
  title: string
  expanded: boolean
}>()

defineEmits<{
  (e: 'toggle'): void
}>()
</script>
